export const styles = {
  root: {
    flexGrow: 1
  },
  toolbar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  grow: {
    flexGrow: 1
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 12
  },
  userButton: {
    marginLeft: 12,
    marginRight: -12
  },
  upload: {
    borderRadius: '10%',
    width: '60px',
    height: '60px',
    fontSize: '44px'
  },
  buttonWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100vw'
  },
  button: {
    margin: '0px 20px 20px 20px',
    width: '90%',
    maxWidth: '500px'
  }
}



// WEBPACK FOOTER //
// ./src/pages/FactoryAnnouncement/styles.js